import axios from "axios";

const domain = process.env.NEXT_PUBLIC_SERVER_DOMAIN;
const basicToken = process.env.NEXT_PUBLIC_BASIC_TOKEN;

export const generalRequest = axios.create({
    baseURL: domain,
    headers: {
        Authorization: `Basic ${basicToken}`,
    },
    timeout: 60000,
});

export const post = async (url: string, option?: any, headers?: any) => {
    const res = await generalRequest.post(url, option, headers);
    return res.data;
};
export const get = async (url: string, option?: any) => {
    const res = await generalRequest.get(url, option);
    return res.data;
};
